import { render, staticRenderFns } from "./SelectedCustomers.vue?vue&type=template&id=7f1b048d&scoped=true&"
import script from "./SelectedCustomers.vue?vue&type=script&lang=ts&"
export * from "./SelectedCustomers.vue?vue&type=script&lang=ts&"
import style0 from "./SelectedCustomers.vue?vue&type=style&index=0&id=7f1b048d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1b048d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VChip,VDivider,VIcon,VListItem,VListItemAction,VListItemContent,VListItemTitle})
